const Raw = ({ data }) => (
  <div className="col-span-2 bg-gray-900 rounded-lg p-5 flex flex-col gap-2">
    <pre className="text-white text-sm overflow-x-scroll">{JSON.stringify(data, null, 2)}</pre>
  </div>
);

export default Raw;
